import styled from 'styled-components';
import { BP_LAPTOP } from '@rsos/constants/breakpoints';
import { Box } from '../../base';

export const LoaderWrapper = styled(Box).attrs({
  width: 120,
  height: 120,
  margin: '90px auto 0',
  padding: '20px',
  justify: 'center',
  align: 'center',
})`
  border: ${({ theme }) => `1px solid ${theme.colors.lightLineDivider}`};
  border-radius: 4px;
`;

export const NoResultsWrapper = styled(Box).attrs({
  align: 'center',
  marginTop: '90px',
})`
  @media (max-width: ${BP_LAPTOP}px) {
    min-height: 250px;
  }
`;

export const ScrollableList = styled(Box).attrs({
  position: 'relative',
})`
  flex: 1 1 auto;
  overflow: hidden;
  &:hover {
    overflow-y: auto;
  }
`;
